const state = {
  specs: {}
}

export default state
